import { render, staticRenderFns } from "./ProductReturnInventory.vue?vue&type=template&id=3d57459e&"
import script from "./ProductReturnInventory.vue?vue&type=script&lang=js&"
export * from "./ProductReturnInventory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports